import { useEffect, useState } from 'react'
import { signOut as nextSignOut } from "next-auth/react"
import { useRouter } from 'next/router'
import { auth } from '../firebase'
import { routes } from '../constants'
import { clearSession } from '../selectors'

export default function useLogout () {
  const[loading, setLoading] = useState(false)
  const[logout, setLogout] = useState(false)
  const router = useRouter()
  const shouldLogout = () =>  setLogout(true)

  const signOut = async () => {
    await nextSignOut();
    return await auth.signOut()
  }

  const afterSignOut = () => {
    clearSession()
    setLoading(false)
    router.push(routes.login)
  } 

  useEffect(() => {
    if (logout) {
      setLoading(true)
      try {
        signOut().then(() => afterSignOut())
      } catch (e) {
        console.error(e)
        afterSignOut()
      }
    }
  }, [logout])

  return { loading, start: shouldLogout }
}